import ContactSupportIcon from "@shared/svg/contact-support.svg?react";
import { AlertBox } from "@shared/ui/AlertBox";
import Headline, { HEADLINE_SIZES } from "@shared/ui/Headline";
import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useNavigate, useLocation } from "react-router-dom";

import { ROUTES_TO_FEATURE_FLAG_MAP_FUTURE_VISION } from "~/components/common/FeatureAccess/constants";
import { useAuth } from "~/components/general";
import { UserType } from "~/types/user";

const FeatureAccess = ({ children }: { children: React.ReactChildren }) => {
  const { user } = useAuth() as { user: UserType };
  const { messages } = useIntl();
  const navigate = useNavigate();
  const location = useLocation();
  const [state, setState] = useState<{
    featureEnabled: boolean;
    featureName: string;
  }>({ featureEnabled: true, featureName: "" });

  useEffect(() => {
    // Skip feature access check for workspace routes
    if (location.pathname.startsWith("/app/workspace")) {
      setState({ featureEnabled: true, featureName: "" });
      return;
    }

    Object.entries(ROUTES_TO_FEATURE_FLAG_MAP_FUTURE_VISION).forEach(
      ([route, featureSpec]) => {
        if (location.pathname.startsWith(route)) {
          setState({
            featureEnabled: user?.productAccess?.includes(
              // @ts-ignore
              featureSpec?.getFlag?.(user) || featureSpec?.flag,
            ),
            // @ts-ignore
            featureName: featureSpec.getFeatureDeniedMessage(messages, user),
          });
        }
      },
    );
  }, [user, location.pathname, messages]);

  return (
    <>
      <AlertBox
        overlay
        isOpen={!state.featureEnabled}
        acceptButtonText={messages?.common?.["okay"]}
        image={<ContactSupportIcon width="130" height="130" />}
        alertContent={
          <Headline size={HEADLINE_SIZES.X_SMALL}>{state.featureName}</Headline>
        }
        onAccept={() => {
          setState({ featureEnabled: true, featureName: "" });
          navigate("/app/asset-hub", { replace: true });
        }}
      />
      {children}
    </>
  );
};

export default FeatureAccess;
